import { ENV, ENV_PROD } from '../../core/config';

export const SHOULD_NOT_SHOW_BANNER = ENV === ENV_PROD;
